import { LinearProgress } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: '6px',
  borderRadius: '10px',
  backgroundColor: theme.tokens.ThemeColorCommonSeparator,
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.tokens.ThemeColorCommonOnSurfaceLink,
  },
  [theme.breakpoints.down('mobile')]: {
    top: 0,
    position: 'fixed',
    borderRadius: 0,
    width: '100vw',
    ml: theme.spacing(-3),
  },
  [theme.breakpoints.up('mobile')]: {
    margin: theme.spacing(0, 0, 2, 0),
    width: '380px',
  },
}))
